
export const actionTypes = {
  ADD : 'accessibility-notifications.add',
  REMOVE : 'accessibility-notifications.remove'
}

export function addNotification(message, alertLevel) {
  return {
    type : actionTypes.ADD,
    message,
    alertLevel,
  }
}

export function removeNotification(id) {
  return {
    type : actionTypes.REMOVE,
    id,
  }
}



// WEBPACK FOOTER //
// src/common/accessibility-notifications/accessibility-notifications.actions.js